/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/jsx-key */
/* eslint-disable radix */
import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { useQuery } from '@apollo/client';
import Loader from 'components/common/Loader';
import moment from 'moment';
import { USER_SUBSCRIPTION_PLANS_BY_TRADER_ID } from 'pages/SubscriptionPlans/subscriptionPlanGraphQL';
import { currencyToLocal } from 'utils/constants';
import ErrorBoundary from 'components/common/ErrorBoundary';

const VendorSubscriberList = ({ vendorId, currency }) => {
  const { data, loading, error } = useQuery(
    USER_SUBSCRIPTION_PLANS_BY_TRADER_ID,
    {
      variables: {
        id: parseInt(vendorId),
      },
      fetchPolicy: 'network-only',
    },
  );

  if (loading) return <Loader />;
  if (error) return `There is an error on this page : ${error.message} `;
  if (!data?.userSubscriptionByTrader) return 'No Data Available';

  return (
    <ErrorBoundary>
      {data?.userSubscriptionByTrader?.map(
        ({
          deactivationDate,
          dealQtyLimit,
          dealQtyUnit,
          subscriptionPlan: { planName, price, discountedAmount, id },
        }) => {
          return (
            <Card className="plan-card border-0" key={id}>
              <CardBody>
                <div className="d-flex justify-content-between">
                  <h5 className="mb-0 f-18 font-inter fw-bold text-primary">
                    {planName}
                  </h5>
                  <div>
                    <p className="mb-0 f-20 font-inter fw-bold">
                      {`${currencyToLocal(discountedAmount, currency)}`}
                      <span className="f-12">/PA</span>
                    </p>
                    <p
                      className="mb-0 text-end text-gray"
                      style={{ marginTop: '-4px' }}
                    >
                      <del>{`${currencyToLocal(price, currency)}`}</del>
                    </p>
                  </div>
                </div>
                <p className="mb-0">
                  <span className="f-14 font-inter d-block text-dark">
                    Valid till -{' '}
                    {moment(deactivationDate).format('D MMM, YYYY')}{' '}
                    {moment(deactivationDate).format('hh:mm A')}
                  </span>
                  <span className="f-14 font-inter d-block text-dark">
                    {dealQtyLimit >= 0
                      ? `${dealQtyLimit} ${dealQtyUnit} Remaining`
                      : 'UNLIMITED'}
                  </span>
                </p>
              </CardBody>
            </Card>
          );
        },
      )}
    </ErrorBoundary>
  );
};

export default VendorSubscriberList;
